import React from 'react';
import { NumericFormat } from 'react-number-format';
import { keycloak } from '../../../../lib/keycloak';
import Input from '../../../../ui/molecules/input';
import { SelectCustom } from '../../../../ui/molecules/select';

interface ComparisonFieldProps {
    value: string;
    onChange: (value: string) => void;
    label: string;
    placeholder?: string;
    disabled?: boolean;
    error?: boolean;
    errorMessage?: string;
}

export const ComparisonFieldRevenue: React.FC<ComparisonFieldProps> = ({
    value,
    onChange,
    label,
    placeholder = "Inserisci valore",
    disabled,
    errorMessage,
    error
}) => {
    const [operator, minValue, maxValue] = value.split(':');

    const handleOperatorChange = (newOperator: string) => {
        const newValue = `${newOperator}:undefined:undefined`;
        onChange(newValue);
    };

    const handleMinChange = (newMin: string) => {
        const newValue = `${operator}:${newMin || 'undefined'}:${maxValue}`;
        onChange(newValue);
    };

    const handleMaxChange = (newMax: string) => {
        const newValue = `${operator}:${minValue}:${newMax || 'undefined'}`;
        onChange(newValue);
    };

    const signMap = new Map<("=" | "<" | ">" | "><"), string>([
        ["=", "Uguale a"],
        ["<", "Minore di"],
        [">", "Maggiore di"],
        ["><", "Compreso tra"],
    ]);

    return (
        <div className="flex gap-4 items-start justify-start">
            <div className='w-full'>
                <SelectCustom
                    isClearable
                    error={error}
                    errorLabel={errorMessage}
                    defaultValue={operator}
                    onChange={(e) => handleOperatorChange(e ? e.toString() : 'undefined')}
                    disabled={disabled || keycloak.hasRealmRole("customer") || keycloak.hasRealmRole("collaborator")}
                    placeholder={"Indifferente"}
                    options={[
                        { label: "Uguale a", value: "=" },
                        { label: "Minore di", value: "<" },
                        { label: "Maggiore di", value: ">" },
                        { label: "Compreso tra", value: "><" },
                    ]}
                    label="Fatturato"
                />
            </div>
            <div className="w-full">
                {operator !== 'undefined' && (
                    <NumericFormat
                        prefix="€ "
                        value={minValue === 'undefined' ? '' : minValue}
                        thousandSeparator="."
                        decimalSeparator=","
                        onValueChange={(e) => handleMinChange(e.floatValue ? e.floatValue.toFixed(2) : '')}
                        decimalScale={2}
                        disabled={disabled || keycloak.hasRealmRole("customer") || keycloak.hasRealmRole("collaborator")}
                        fixedDecimalScale
                        label={signMap.get(operator as "=" | "<" | ">" | "><") || ""}
                        // error={error}
                        // supportingText={error ? "Inserire il fatturato" : ""}
                        customInput={Input}
                        id={"company-to-confirm-price-min"}
                        key={"company-to-confirm-price-min"} />
                )}
            </div>
            <div className="w-full">
                {operator === '><' && (
                    <NumericFormat
                        prefix="€ "
                        value={maxValue === 'undefined' ? '' : maxValue}
                        thousandSeparator="."
                        decimalSeparator=","
                        onValueChange={(e) => handleMaxChange(e.value)}
                        decimalScale={2}
                        disabled={disabled || keycloak.hasRealmRole("customer") || keycloak.hasRealmRole("collaborator")}
                        fixedDecimalScale
                        label={signMap.get(operator as "=" | "<" | ">" | "><") || ""}
                        // error={error}
                        // supportingText={error ? "Inserire il fatturato" : ""}
                        customInput={Input}
                        id={"company-to-confirm-price-max"}
                        key={"company-to-confirm-price-max"}
                    />
                )}
            </div>
        </div>
    );
};